<template>
  <div v-if="assemblyProduct.name">
    <div
      :class="{
        'product-configurator-option product-configurator-option-montage': true,
      }"
    >
      <div class="row">
        <div class="configurator-option-head col-xs-4">
          Montage <span class="badge badge-primary-full badge-sm">Neu</span>
        </div>
        <div class="configurator-option-content col-xs-8">
          <slot />
        </div>

        <div class="configuratior-option-description col-xs-12">
          Die <strong>Zaun24 Profi-Montage</strong> zum Festpreis.
        </div>
      </div>

      <div class="configurator-option-info" @click="toggleConfigModal()">
        <img src="/assets/icon/icon-info.svg" alt="Mehr über die Montage erfahren">
      </div>

      <modal name="modal-configurator-option" :width="1000" class="configurator-option-info-modal">
        <div slot="header">
          <div class="badge badge-primary-full">
            Neu
          </div>
          <div class="head head-lg">
            {{ assemblyProduct.name }}
          </div>
        </div>

        <div slot="content">
          <div class="montage-box">
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <div class="content">
                  <div class="montage-description" v-html="assemblyProduct.description" />
                  <!--<div class="montage-price-box">
                    ab {{ assemblyProduct.price_incl_tax | price }}/m
                  </div>-->
                  <a
                    href="/montageservice/"
                    class="btn btn-secondary"
                    @click="toggleConfigModal()"
                    target="_blank"
                  >
                    Mehr erfahren
                  </a>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <img src="/assets/content/profi-montage.jpg">
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from 'theme/components/core/Modal'

export default {
  components: {
    Modal
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct'
    })
  },
  props: {
    assemblyProduct: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toggleConfigModal () {
      this.$bus.$emit('modal-toggle', 'modal-configurator-option');
    }
  }
}
</script>
